var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkGreenTickIcon = function SvgCkGreenTickIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4997 15.172L19.6917 5.979L21.1067 7.393L10.4997 18L4.13574 11.636L5.54974 10.222L10.4997 15.172Z",
    fill: "#5D7D2B"
  })));
};
export { SvgCkGreenTickIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjUiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNSAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjQ5OTcgMTUuMTcyTDE5LjY5MTcgNS45NzlMMjEuMTA2NyA3LjM5M0wxMC40OTk3IDE4TDQuMTM1NzQgMTEuNjM2TDUuNTQ5NzQgMTAuMjIyTDEwLjQ5OTcgMTUuMTcyWiIgZmlsbD0iIzVEN0QyQiIvPgo8L3N2Zz4K";